export var OrganizationType;
(function (OrganizationType) {
    OrganizationType["TECHNICAL"] = "technical";
    OrganizationType["BUSINESS"] = "business";
})(OrganizationType || (OrganizationType = {}));
//# sourceMappingURL=organization-type.enum.js.map